"use client";
import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PageTransition from "@/components/animations/PageTransition";
import Breadcrumb from "@/components/Breadcrumb";
import ServicesBento from "@/app/home-page/components/ServicesBento";

export default function ServicesPage() {
  return (
    <PageTransition>
      <main style={{ background: "#070B14", overflowX: "hidden" }}>
        <Header />
        <Breadcrumb
          items={[
            { label: "Home", href: "/" },
            { label: "Services" },
          ]}
        />
        <div className="pt-20">
          <ServicesBento />
        </div>
        <Footer />
      </main>
    </PageTransition>
  );
}
